import { __exportAll } from "../_virtual/_rolldown/runtime.js";
//#region src/utils/item_array_utils.ts
var item_array_utils_exports = /* @__PURE__ */ __exportAll({
	getI9nItemWithId: () => getI9nItemWithId,
	getItemIds: () => getItemIds,
	getItemWithId: () => getItemWithId,
	hasItemWithId: () => hasItemWithId,
	hasNotHiddenOrArchivedItemRefs: () => hasNotHiddenOrArchivedItemRefs
});
function getItemIds(data) {
	return data.items.map(({ _id }) => _id);
}
function getItemWithId(data, itemId) {
	return data.items.find(({ _id }) => {
		return _id.equals(itemId);
	});
}
function getI9nItemWithId(data, itemId) {
	const index = data.items.findIndex(({ _id }) => {
		return _id.equals(itemId);
	});
	if (index >= 0 && index < (data.i9nItems?.length || 0)) return data.i9nItems[index];
}
function hasItemWithId(data, itemId) {
	return !!getItemWithId(data, itemId);
}
function hasNotHiddenOrArchivedItemRefs(data, visibilityByItemId) {
	if (!data.items?.length) return false;
	return data.items.some((itemRef) => {
		return visibilityByItemId[itemRef._id.toString()];
	});
}
//#endregion
export { getI9nItemWithId, getItemIds, getItemWithId, hasItemWithId, hasNotHiddenOrArchivedItemRefs, item_array_utils_exports };

//# sourceMappingURL=item_array_utils.js.map